<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>AI</el-breadcrumb-item>
			</el-breadcrumb>
		</div>



<div class="chat-main" v-loading="loading" border element-loading-text="拼命加载中">
	<div
  v-for="(item, index) in listData"
  class="chat-item"
  :class="[index%2===1 ? 'question' :'answer']"
  :key="index"
>
  <!-- 1.对方头像 --> 
  <div class="header-img-wrapper">
    <el-image v-if="index%2===1" :src="require('../../assets/img/rabit.png')" class="header-img" ></el-image>
  </div>


  <!-- 2.内容 --> 
  <div class="content">
    <div class="content-width">{{ item.answer }}</div>
    <div class="indicator"></div>  <!-- 小箭头 --> 
  </div>
  <!-- 3.我方头像 --> 
  <div class="header-img-wrapper">
    <el-image v-if="index%2===0" :src="require('../../assets/img/favicon.png')" class="header-img"></el-image>
  </div>
</div>


<el-card class="box-card" style="margin-bottom: 20px;text-align: right;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<el-form-item label="" >
					<el-input style="width:600px" size="big" placeholder="请输入关键词" v-model="formInline.queryString" clearable ></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search">提问</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		
</div>





		<!-- <div>
			<el-input type="textarea" resize="none" :autosize="{ minRows: 2}" v-model="editForm.introduction"></el-input>
		</div> -->

		<!--列表-->
		<el-table v-if="false" size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column type="index" width="50" align="center"> </el-table-column>
			<el-table-column prop="queryString" label="搜索关键词" align="center" width="150" > </el-table-column>
			<el-table-column prop="answer" label="AI内容" align="center"></el-table-column>
			<el-table-column prop="queryTime" label="搜索时间" align="center" width="150" > </el-table-column>

		</el-table>
		<!-- 分页组件 -->
		<Pagination v-if="false" :child-msg="pageparm" @callFather="callFather"></Pagination>



	</div>
</template>

<script>
	import {
		startmoxing
	} from '../../api/basisMG.js'
	// import quillEdit from '../../components/quillEdit'
	// import quillEdit from 'vue-quill-editor'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	// import uploadwgt from '@/components/uploadwgt'
	// 导出模块
	export default {
		components: {
			// uploadwgt,
			// quillEdit
		},

		// 模块数据
		data() {
			//数据  
			return {
				editbj:{},
				editorOption: {} ,
				decernerVisible:false,
				goodsImg: '',
				loading: false,
				
                isShow: false,
				visible: false,
				listData: [],
				dialogVisible: false,
				formInline: {
					start: 0,
					length: 10
				},
				editForm: {
					content:''
				},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10,
					start: 0,
					length: 10
				},
			}
		},


		watch: {},

		methods: {
			getContent(content) {
				this.editForm.content = content
			},
			
			
			getdata() {
				this.loading=true;
                this.isShow = true;
            //  this.qts();
				startmoxing(this.formInline).then(res => {
					this.saveParams(this.$route.path,this.formInline)
					if (res.code == 200) {
						this.listData = res.data
						this.isShow = false
						this.loading=false
					//	this.qts();
						this.pageparm.total = res.data.totalElements
					}
				})
			},

			qts() {
                if (this.isShow) {
                    this.$toast.loading({ message: "加载中···", duration: 0, forbidClick: true });
                }else{
                    this.$toast.loading({ message: "加载中···", duration: 10, forbidClick: true });
 
                }
            },

			// 分页插件事件
			callFather(parm) {
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.pageparm.start = parm.currentPage - 1
				this.pageparm.length = parm.pageSize
				this.formInline.start = parm.currentPage - 1
				this.formInline.length = parm.pageSize
				this.getdata(this.formInline)
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>




.chat-main {
  width: 60%;
  height: 67%;
  padding: 20px;
  margin: 0 auto;
  overflow-y: auto; 
 
  .chat-item {
    display: flex;
    justify-content: space-between;
    text-align: left;
 
    .header-img-wrapper {
      width: 60px;
      height: 60px;
      .header-img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }
   
    .content {
      flex: 1;
      font-size: 16px;
      color: #ffffff;
      margin: 0 30px;
      position: relative;
      border-radius: 4px;
      padding: 16px 20px;
      line-height: 23px; 
    } 
  }
  

    
  .chat-item.question .content {
    background: rgba(31, 159, 191, 0.9);
    border: 1px solid #74eaff;
    box-shadow: 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff,
      0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff;
  }
  .chat-item.question .indicator {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid rgba(31, 159, 191, 0.9);
    position: absolute;
    left: -8px;
    top: 16px;
    box-shadow: 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff,
      0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff;
    background-image: url("../../assets/img/logo.png");
    background-size: 100% 100%;
  }

  .chat-item.answer .content {
    background: rgba(0, 22, 87, 0.9);
    border: 1px solid #74eaff;
    box-shadow: 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff,
      0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff;
  }

  .chat-item.answer .indicator {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid rgba(0, 22, 87, 0.9);
    position: absolute;
    right: -8px;
    top: 16px;
    box-shadow: 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff,
      0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff, 0 0 20px -8px #74eaff;
  }

  .chat-item:not(:first-child) {
    margin-top: 38px;
  }
}  


</style>
